// extracted by mini-css-extract-plugin
module.exports = {"root":"_3IPsB","wrapper":"_2DdFd","searchWrapper":"_3z3wf","title":"_2uRhI","subtitle":"_1RWiF"};